import { render, staticRenderFns } from "./broker-nav.vue?vue&type=template&id=2ca050a1&scoped=true"
import script from "./broker-nav.vue?vue&type=script&lang=js"
export * from "./broker-nav.vue?vue&type=script&lang=js"
import style0 from "./broker-nav.vue?vue&type=style&index=0&id=2ca050a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca050a1",
  null
  
)

export default component.exports